<template>
  <div
    v-if="show"
    class="search-dropdown"
  >
    <div class="search-dropdown__tabs">
      <button
        v-for="tab of tabs"
        :key="tab"
        :class="{ active: activeTab === tab }"
        type="button"
        @click="activeTab = tab"
      >
        {{ tab }}
      </button>
    </div>
    <div
      v-if="hasResultsForActiveTab"
      class="search-dropdown__results"
    >
      <ul
        v-if="activeTab === 'PRODUCTS' && limitedProducts.length > 0 && query"
        class="search-dropdown__results__products"
      >
        <li
          v-for="(product, index) of limitedProducts"
          :key="product.id"
          class="search-dropdown__product-card"
        >
          <product-card
            :product="product"
            :show-btn-discount="showBtnDiscount"
            :lazyload="index > 4"
          />
        </li>
      </ul>
      <ul
        v-else-if="activeTab === 'COLLECTIONS'"
        class="search-dropdown__results__list"
      >
        <li v-if="collections.length === 0">
          {{ $string('collection.no_results') }}
        </li>
        <li
          v-for="collection of collections"
          :key="collection.id"
        >
          <a
            :href="collection?.link"
            class="search-dropdown__collection-link"
            tabindex="0"
          >
            <span>{{ extractPathSegment(collection?.link).toUpperCase() }}</span>
          </a>
        </li>
      </ul>
      <ul
        v-else-if="activeTab === 'PAGES'"
        class="search-dropdown__results__pages"
      >
        <li
          v-for="page of pages"
          :key="page.id"
        >
          <a
            :href="page?.link"
            class="search-dropdown__results__pages__link"
            tabindex="0"
          >
            <span>{{ extractPathSegment(page?.link).toUpperCase() }}</span>
          </a>
        </li>
      </ul>
      <ul
        v-else-if="activeTab === 'BLOGS'"
        class="search-dropdown__results__list"
      >
        <li
          v-for="blog of blogs"
          :key="blog.id"
        >
          <a
            :href="blog?.link"
            class="search-dropdown__results__pages__link"
            tabindex="0"
          >
            <span>{{ blog?.displayString.toUpperCase() }}</span>
          </a>
        </li>
      </ul>
      <div
        v-if="activeTab === 'PRODUCTS' && products.length > 5"
        class="search-dropdown__view-all"
      >
        <btn
          :label="$string('search.view_all')"
          :url="searchUrl"
          class="search__primary"
          modifiers=""
        />
      </div>
    </div>
    <div
      v-if="query && (
        (activeTab === 'PRODUCTS' && limitedProducts.length === 0) ||
        (activeTab === 'COLLECTIONS' && collections.length === 0) ||
        (activeTab === 'PAGES' && pages.length === 0) ||
        (activeTab == 'BLOGS' && blogs.length === 0)
      )"
      class="search-dropdown__no-results"
    >
      {{ $string('search.no_results') }}
    </div>
  </div>
</template>

<script>
import ProductCard from '~async/product-card/product-card'
import Btn from '~global/btn/btn.vue'
export default {
  name: 'SearchDropdown',
  components: {
    ProductCard,
    Btn,
  },
  props: {
    show: Boolean,
    products: {
      type: Array,
      default: () => [],
    },
    collections: {
      type: Array,
      default: () => [],
    },
    pages: {
      type: Array,
      default: () => [],
    },
    blogs: {
      type: Array,
      default: () => [],
    },
    query: {
      type: String,
      default: '',
    },
    showBtnDiscount: {
      type: String,
      default: 'show',
    },
  },
  data() {
    return {
      activeTab: 'PRODUCTS',
    }
  },
  computed: {
    hasResultsForActiveTab() {
      if (!this.query) {
        return true
      }
      const resultMap = {
        PRODUCTS: this.limitedProducts.length > 0,
        COLLECTIONS: this.collections.length > 0,
        PAGES: this.pages.length > 0,
        BLOGS: this.blogs.length > 0,
      }

      return resultMap[this.activeTab] || true
    },
    tabs() {
      const tabs = []
      if (this.products.length > 0) {
        tabs.push('PRODUCTS')
      }
      if (this.collections.length > 0) {
        tabs.push('COLLECTIONS')
      }
      if (this.pages?.length > 0) {
        tabs.push('PAGES')
      }
      if (this.blogs?.length > 0) {
        tabs.push('BLOGS')
      }
      return tabs
    },
    limitedProducts() {
      return this.products.slice(0, 5)
    },
    searchUrl() {
      // Use the same search URL logic as in main-search.vue
      const base = this.$variable
        ? this.$variable('routes.search') || '/search'
        : '/search'
      return this.query
        ? `${base}?q=${encodeURIComponent(this.query)}`
        : base
    },
  },
  methods: {

    /**
     * Extract the last segment from a URL path
     * @param {String} link - Full URL or path
     * @returns {String} - Last segment of the path
     */
    extractPathSegment(link) {
      if (!link) {
        return ''
      }

      try {
        const cleanLink = link.replace(/\/$/, '')
        const segments = cleanLink.split('/')
        const lastSegment = segments[segments.length - 1]
        return lastSegment
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      } catch (error) {
        return link
      }
    },
  },
}
</script>

<style lang="scss">
@import './search-dropdown.scss';
</style>
